const blockTextMedia = {
  'block.text-media': {
    populate: {
      text: {
        populate: '*',
      },
      picture: {
        populate: '*',
      },
      logo: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
      textBlobStyle: {
        populate: '*',
      },
      imageBlobStyle: {
        populate: '*',
      },
      logoBlobStyle: {
        populate: '*',
      },
    },
  },
};

const blockHeroSection = {
  'block.hero-section': {
    populate: '*',
  },
};

const blockJobDetails = {
  'block.job-details': {
    populate: {
      jobDetails: {
        populate: {
          text: {
            populate: '*',
          },
        },
      },
      tags: {
        populate: '*',
      },
      titleOverview: {
        populate: '*',
      },
      paragraphOverview: {
        populate: '*',
      },
    },
  },
};

const blockFaq = {
  'block.faq': {
    populate: {
      faqItems: {
        populate: '*',
      },
      title: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockFramedPictures = {
  'block.framed-pictures': {
    populate: {
      text: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockNumberedList = {
  'block.numbered-list': {
    populate: {
      title: {
        populate: '*',
      },
      paragraph: {
        populate: '*',
      },
      items: {
        populate: '*',
      },
      cta: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockCustomerCases = {
  'block.customer-cases': {
    populate: {
      cases: {
        populate: {
          title: {
            populate: '*',
          },
          paragraph: {
            populate: '*',
          },
          picture: {
            populate: '*',
          },
          bubbleStyle: {
            populate: {
              theme: true,
            },
          },
        },
      },
      cta: {
        populate: '*',
      },
      title: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

/** Populate léger pour enrichir les cas client sans écraser title/paragraph (bug Strapi). */
const customerCasesClientPagePopulate = {
  on: {
    'block.customer-cases': {
      populate: {
        cases: {
          fields: ['id'],
          populate: {
            clientPage: {
              fields: ['slug'],
              populate: {
                zolClient: {
                  fields: ['name', 'slogan'],
                  populate: {
                    logo: {
                      populate: '*',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

const blockActivities = {
  'block.activities': {
    populate: {
      activities: {
        populate: '*',
      },
      title: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockTextAccordion = {
  'block.text-accordion': {
    populate: {
      text: {
        populate: '*',
      },
      accordions: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockDoudouList = {
  'block.doudou-list': {
    populate: {
      title: {
        populate: '*',
      },
      doudous: {
        // Strapi relation
        filters: {
          publishedAt: {
            $notNull: true,
          },
        },
        populate: {
          avatar: {
            populate: '*',
          },
        },
      },
      cta: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockMockup = {
  'block.mockup': {
    populate: '*',
  },
};

const blockClientOverview = {
  'block.client-overview': {
    populate: {
      title: {
        populate: '*',
      },
      titleOverview: {
        populate: '*',
      },
      overview: {
        populate: '*',
      },
      main: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockOffers = {
  'block.offers': {
    populate: {
      offers: {
        // Strapi relation
        populate: '*',
        filters: {
          publishedAt: { $notNull: true },
        },
      },
      cta: {
        populate: '*',
      },
      title: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockQuotation = {
  'block.quotation': {
    populate: {
      logo: {
        populate: '*',
      },
      bubbleStyle: {
        populate: '*',
      },
    },
  },
};

const blockPress = {
  'block.press': {
    populate: {
      title: {
        populate: '*',
      },
      items: {
        populate: '*',
      },
      cta: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockLogoClients = {
  'block.logo-clients': {
    populate: {
      text: {
        populate: '*',
      },
      clients: {
        populate: '*',
      },
      keyFigures: {
        populate: {
          title: {
            populate: '*',
          },
          paragraph: {
            populate: '*',
          },
          bubbleStyle: {
            populate: '*',
          },
        },
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockFormOffer = {
  'block.form-offer': {
    populate: '*',
  },
};

const blockFormApplication = {
  'block.form-job-application': {
    populate: '*',
  },
};

const blockWysiwyg = {
  'block.wysiwyg': {
    populate: '*',
  },
};

const blockTextBubbles = {
  'block.bulles-de-textes': {
    populate: {
      content: {
        populate: '*',
      },
      bubbles: {
        populate: {
          content: {
            populate: '*',
          },
          bubbleStyle: {
            populate: '*',
          },
        },
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockDualImageTextSection = {
  'block.deux-images-texte-centrale': {
    populate: {
      leftImage: {
        populate: '*',
      },
      rightImage: {
        populate: '*',
      },
      text: {
        populate: '*',
      },
      waveWrapper: {
        populate: '*',
      },
    },
  },
};

const blockIllustration = {
  'block.illustration': {
    populate: {
      waveWrapper: {
        populate: '*',
      },
      columns: {
        populate: {
          lines: {
            populate: {
              items: {
                populate: {
                  image: {
                    populate: '*',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

export { customerCasesClientPagePopulate };

export const blocks = {
  on: {
    ...blockTextMedia,
    ...blockHeroSection,
    ...blockJobDetails,
    ...blockFaq,
    ...blockFramedPictures,
    ...blockNumberedList,
    ...blockCustomerCases,
    ...blockActivities,
    ...blockTextAccordion,
    ...blockDoudouList,
    ...blockMockup,
    ...blockClientOverview,
    ...blockOffers,
    ...blockQuotation,
    ...blockPress,
    ...blockLogoClients,
    ...blockFormOffer,
    ...blockFormApplication,
    ...blockWysiwyg,
    ...blockTextBubbles,
    ...blockDualImageTextSection,
    ...blockIllustration,
  },
};

export const header = {
  menus: {
    populate: {
      dropdown: {
        populate: {
          overview: {
            populate: '*',
          },
          linkGroup: {
            populate: '*',
          },
          picture: {
            fields: ['*'],
          },
        },
      },
    },
  },
  cta: {
    populate: '*',
  },
};

export const footer = {
  groups: {
    populate: {
      links: {
        populate: '*',
      },
    },
  },
  addresses: {
    populate: '*',
  },
  socialMedia: {
    populate: '*',
  },
  partners: {
    populate: '*',
  },
  preFooter: {
    populate: '*',
  },
  legalLinks: {
    populate: '*',
  },
  logo: {
    populate: '*',
  },
};

export const seo = {
  fields: ['metaTitle', 'metaDescription'] as const,
};

export const article = {
  cover: {
    populate: '*',
  },
  author: {
    populate: '*',
  },
  category: {
    populate: '*',
  },
  tags: {
    populate: '*',
  },
};

export const contact = {
  title: {
    populate: '*',
  },
  paragraph: {
    populate: '*',
  },
  formTitle: {
    populate: '*',
  },
  formParagraph: {
    populate: '*',
  },
  expertises: {
    populate: '*',
  },
  types: {
    populate: '*',
  },
  budgets: {
    populate: '*',
  },
  origins: {
    populate: '*',
  },
};
